module.exports = __webpack_public_path__ + "media/images/pc/top/area_brand_tvb@3x-49559b2aa2d727fabbc65222699fdd85.webp";